/**
 *   element.scrollIntoView() is not behaving as expected inside iframe.
 *
 *  This function is a workaround to scroll the element into view.
 * */
import { makeLogger } from "@/shared/consola";

const logger = makeLogger(useScrollIntoView.name);

export function useScrollIntoView() {
    return {
        scrollInto(parent: HTMLElement | null, webId: string) {
            requestAnimationFrame(() => {
                const element = parent?.querySelector(`#${CSS.escape(webId)}`);
                if (!element) {
                    return;
                }
                const scrollContainer = document.body;
                const elementRect = element.getBoundingClientRect();
                const containerRect = scrollContainer.getBoundingClientRect();
                const top = elementRect.top - containerRect.top + scrollContainer.scrollTop || 0;

                logger.trace("useScrollIntoView.scrollInto", webId, top);
                window.scrollTo({
                    top,
                    behavior: "smooth",
                });
            });
        },
    };
}
